import { reportError } from "./reportError";

const installGlobalErrorHandlers = () => {
  if (typeof window === "undefined" || window.__portfolioErrorHandlersInstalled) {
    return;
  }

  window.__portfolioErrorHandlersInstalled = true;

  window.addEventListener("error", (event) => {
    reportError(event.error || event.message, {
      fatal: false,
      source: "window.error",
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    reportError(event.reason, {
      fatal: false,
      source: "unhandledrejection",
    });
  });
};

export const startErrorReporting = () => {
  installGlobalErrorHandlers();
};
